"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableItemCard = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ClickableItemCard = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const handleOnClick = (event) => {
        if (props.handleOnClick) {
            props.handleOnClick(event);
        }
        if (props.path) {
            navigate(props.path);
        }
    };
    return (react_1.default.createElement("div", { className: props.className, onClick: handleOnClick, id: props.id }, props.children));
};
exports.ClickableItemCard = ClickableItemCard;
